var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 7"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.141 4.394L10.243.293a1 1 0 011.414 1.414l-4.95 4.95a1 1 0 01-1.414 0l-4.95-4.95A1 1 0 011.757.293L5.86 4.394a.2.2 0 00.282 0z"
  })));
}
export default SvgArrowDown;